class AdvertAddPageController {

  constructor(AdvertService, LoaderService, AlertService, Upload, $state, $stateParams) {
    this.AdvertService = AdvertService;
    this.LoaderService = LoaderService;
    this.AlertService = AlertService;
    this.Upload = Upload;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    var self = this;
    self.files = [];
      self.validation = {};
    self.countFileUploaded = 0;
    self.imageEndpoint = "/api/upload";
    self.advert = angular.copy(self.AdvertService.getNew());
    self.advert.type = self.$stateParams.advertType; // set as Feature Advert
    self.returnSuccessState = self.$stateParams.returnSuccessState ? self.$stateParams.returnSuccessState : 'app.advertising.feature';
  }

  storeFile(picFile) {
    this.files[0] = picFile;
  }

  save() {
    var self = this;

      if(!self.validForm()){
          self.AlertService.error("The form has validation errors.");
          return;
      }

      self.LoaderService.start();

      return self.AdvertService.processLinkTypes(self.advert, self.linkValues)
          .then(function(advert){
              self.advert = advert;
              self.LoaderService.start();
              return self.AdvertService.addNew(self.advert, self.files[0])
                  .then(() => {
                      // empty the file array
                      self.files.splice(0, self.files.length);
                          self.AlertService.success("Advert has been updated");
                          self.$state.go(self.returnSuccessState);
                      }
                  )
                  .catch((error) => {
                      if(error.type === 'image'){
                          self.validation = {};
                          self.validation.bannerImage = error.message;
                          self.AlertService.error("The form has validation errors.");
                          // empty the file array
                          self.files.splice(0, self.files.length);
                      }
                      else{
                          self.AlertService.error("There was a problem saving the Advert");
                      }
                  })
                  .finally(()=> {
                      self.LoaderService.stop();
                  });
          });

  }


    validForm() {
        var self = this;
        //validation

        self.validation = {};

        if(self.advert.title === undefined || self.advert.title === ''){
            self.validation.name = 'Name is required';
        }
        if(self.files[0] === undefined){
            self.validation.bannerImage = 'You need to include a Banner image';
        }
        if(self.advert.type == 2 && (self.advert.socialCategory === null || self.advert.socialCategory === undefined)){
            this.validation.socialCategory = 'Social Category is required';
        }
        if(self.advert.linkType === null || self.advert.linkType === undefined){
            this.validation.link = 'Link Type is required';
        }

        if(self.isEmpty(self.validation)){
            return true;
        }
        else{
            return false;
        }

    }

    isEmpty(obj) {

        // null and undefined are "empty"
        if (obj == null) return true;

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0)    return false;
        if (obj.length === 0)  return true;

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") return true;

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) return false;
        }

        return true;
    }
}
AdvertAddPageController.$inject = ['AdvertService', 'LoaderService', 'AlertService', 'Upload', '$state', '$stateParams'];
export default AdvertAddPageController;
